export default "__VITE_ASSET__37b318a9__"